import { selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

/**
 * Atom that selects all answers from the questionnaire state.
 *
 * Note: This atom will trigger re-renders whenever ANY answer changes.
 * For better performance when only accessing individual answers,
 * prefer using `questionnaireAnswerAtom(questionName)` which provides
 * selective subscriptions.
 *
 * This atom is useful for components that need to read multiple answers
 * where the number of answers is dynamic (e.g., PercentageQuestion with
 * variable labels from config).
 */
export const questionnaireAnswersAtom = selectAtom(
  questionnaireReducerAtom,
  state => state.answers,
);
